import React, { useContext } from 'react';
import { Navbar, Nav, NavItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import AppContext from '../../context/Context';
import ProfileDropdown from './ProfileDropdown';
import NotificationDropdown from './NotificationDropdown';
import NavbarTopMenu from './NavbarTopMenu';
import Logo from './Logo';

const isDesktopViewport = () => window.matchMedia('(min-width: 1200px)').matches;

const NavbarTop = () => {
  const {
    showBurgerMenu,
    setShowBurgerMenu,
    isDark,
    setIsDark,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    navbarPosition
  } = useContext(AppContext);

  const hasTopMenu = navbarPosition === 'top' || navbarPosition === 'combo';
  const showSidebarToggle = navbarPosition !== 'top';
  const showTopLogo = navbarPosition === 'top';

  const handleNavbarToggle = () => {
    if (!showSidebarToggle) {
      setShowBurgerMenu(!showBurgerMenu);
      return;
    }

    if (isDesktopViewport()) {
      setIsSidebarCollapsed(!isSidebarCollapsed);
      return;
    }

    setShowBurgerMenu(!showBurgerMenu);
  };

  return (
    <Navbar light className={classNames('navbar-glass row navbar-top sticky-kit psi-navbar-top', { glass: isDark })} expand>
      <div className="psi-navbar-top-shell">
        <div className="psi-navbar-top-head">
          <div className="psi-navbar-top-main">
            <div className="psi-navbar-top-copy">
              {showSidebarToggle && (
                <button
                  type="button"
                  id="burgerMenu"
                  className="psi-navbar-top-toggle"
                  onClick={handleNavbarToggle}
                  aria-label="Yon menyuni boshqarish"
                >
                  <span className="psi-navbar-top-toggle-lines" aria-hidden="true">
                    <span className="is-short" />
                    <span className="is-long" />
                    <span className="is-short" />
                  </span>
                </button>
              )}
              {showTopLogo && <Logo at="navbar-top" className="psi-navbar-top-logo" />}
            </div>

            {hasTopMenu && (
              <div className="psi-navbar-top-menu-shell">
                <NavbarTopMenu />
              </div>
            )}
          </div>

          <Nav navbar className="align-items-center ml-auto psi-navbar-actions">
            <NotificationDropdown />
            <NavItem>
              <button
                type="button"
                className="psi-theme-toggle"
                onClick={() => setIsDark(!isDark)}
                aria-label="Tungi rejimni boshqarish"
              >
                <FontAwesomeIcon icon={isDark ? 'sun' : 'moon'} />
              </button>
            </NavItem>
            <ProfileDropdown />
          </Nav>
        </div>
      </div>
    </Navbar>
  );
};

export default NavbarTop;
